import "antd/es/form/style";
import _Form from "antd/es/form";
import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { Group, ProFormItem } from '../../components';
import { BaseForm } from '../../BaseForm';

function ProForm(props) {
  return /*#__PURE__*/React.createElement(BaseForm, _extends({
    layout: "vertical",
    submitter: {
      // 反转按钮，在正常模式下，按钮应该是主按钮在前
      render: function render(_, dom) {
        return dom.reverse();
      }
    },
    contentRender: function contentRender(items, submitter) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, items, submitter);
    }
  }, props));
}

ProForm.Group = Group;
ProForm.useForm = _Form.useForm;
ProForm.Item = ProFormItem;
export { ProForm };